import { Box, Text, Grid } from '@stitch-fix/mode-react';
import styles from './style.module.scss';

export type QuotesProps = {
  quotes: {
    text: string;
    name: string;
    title: string;
  }[];
};

export const Quotes = ({ quotes }: QuotesProps) => (
  <Box className={styles.container} m="0 auto" p="3rem 0" maxWidth="1300px">
    <Grid columns={{ sm: 1, md: 3 }} spacing="none">
      {quotes.map(quote => (
        <Box
          className={styles.quote}
          key={quote.name}
          p="0 1.5rem"
          mx="auto"
          mb={{
            sm: 1.5,
            md: 0,
          }}
          maxWidth="400px"
        >
          <Text setting="body-small" mb={1}>
            “{quote.text}”
          </Text>
          <Box>
            <Text setting="body-small">- {quote.name}</Text>
            <Text setting="body-small">{quote.title}</Text>
          </Box>
        </Box>
      ))}
    </Grid>
  </Box>
);
